import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import Button from 'js/components/Button'
import Text from 'js/components/Text/Text'
import getUrls from 'js/magazine-issue/lib/getUrls'
import type { MagazineIssueViewEntity } from 'js/magazine-issue/View/View.types'

import CoverArticle from './CoverArticle'
import styles from './CoverPage.module.css'

type CoverPageProps = {
    entity: MagazineIssueViewEntity
}

const CoverPage = ({ entity }: CoverPageProps) => {
    const { t } = useTranslation()

    const { guid, articles, backgroundColor } = entity

    const urls = getUrls(guid)

    if (!articles.length) {
        return (
            <div className={styles.noArticles}>
                <Text>{t('entity-magazine.no-articles')}</Text>
                <Button
                    as={Link}
                    to={urls.addArticle}
                    variant="secondary"
                    size="large"
                >
                    {t('entity-magazine.create-article')}
                </Button>
            </div>
        )
    }

    const articlesCount = articles.length

    return (
        <div className={styles.wrapper}>
            <div
                className={styles.grid}
                style={
                    {
                        '--cover-grid-area-1':
                            articlesCount > 1 ? 'a' : 'a / a / c / b',
                        '--cover-grid-area-2':
                            articlesCount > 2 ? 'b' : 'b / c / c',
                    } as React.CSSProperties
                }
            >
                {articles.slice(0, 3).map((articleEntity, index) => (
                    <CoverArticle
                        key={articleEntity.guid}
                        index={index}
                        entity={articleEntity}
                        issueBackgroundColor={backgroundColor}
                    />
                ))}
            </div>
        </div>
    )
}

export default CoverPage
